import AppCache from "./appCache";

export const navBarHelper = {
    getNavigationBar,
    getNavigationBarByPathname,
    getNavigationBarByPartner
}

function getNavigationBarByPartner(user, partnerId, partnerName) {
    let nav = [
        {
            label: 'Account List',
            to: '#/partners',
            isVisible: user.roleId == 110,
            icon: 'fas fa-building'
        },
        {
            label: partnerName,
            isPartner: true,
            to: `#/partnersettings/${partnerId}`,
            isVisible: true
        },
        {
            label: 'Templates',
            to: `#/decisiontemplates/${partnerId}`,
            isVisible: true,
            icon: 'far fa-list-alt'
        },
        {
            label: 'Users',
            to: `#/users/${partnerId}`,
            isVisible: true,
            icon: "fas fa-users"
        },
        {
            label: 'System Admin',
            to: '#/sysadmin',
            isVisible: user.roleId == 110,
            icon: 'fas fa-cogs'
        }
    ];

    nav = nav.filter(x => x.isVisible);

    return nav;
}

function getNavigationBarByPathname(user, pathname, partnerId) {
    let nav = [
        {
            label: 'Partner List',
            to: '#/partners',
            isVisible: user.roleId == 110,
            icon: 'fas fa-building'
        },
        {
            label: 'Templates',
            icon: 'far fa-list-alt',
            to: `#/decisiontemplates/${partnerId}`,
            isVisible: pathname.indexOf('/partnersettings/') > -1 ||
                pathname.indexOf('/decisiontemplate/') > -1 ||
                pathname.indexOf('/users') > -1 ||
                pathname.indexOf('/objective/') > -1 ||
                pathname.indexOf('/alternative/') > -1 ||
                pathname.indexOf('/metric/') > -1
        },
        {
            label: 'Users',
            to: `#/users/${partnerId}`,
            icon: "fas fa-users",
            isVisible: pathname.indexOf('/partnersettings/') > -1 ||
                pathname.indexOf('/decisiontemplate/') > -1 ||
                pathname.indexOf('/users') > -1 ||
                pathname.indexOf('/objective/') > -1 ||
                pathname.indexOf('/alternative/') > -1 ||
                pathname.indexOf('/metric/') > -1
        },
        {
            label: 'System Admin',
            to: '#/sysadmin',
            isVisible: user.roleId == 110,
            icon: 'fas fa-cogs'
        }
    ];

    nav = nav.filter(x => x.isVisible);

    return nav;
}

function getNavigationBar(user) {
    let partner = AppCache.getPartner();
    if (partner !== undefined && partner !== null) {
        return getNavigationBarByPartner(user, partner.partnerId, partner.partnerName);
    }

    let nav = [
        {
            label: 'Account List',
            to: '#/partners',
            isVisible: user && user.roleId == 110,
            icon: 'fas fa-building'
        },
        {
            label: 'User List',
            to: '#/fullusers',
            isVisible: user && user.roleId == 110,
            icon: 'fas fa-users'
        },
        {
            label: user.partnerName,
            isPartner: true,
            to: `#/partnersettings/${user.partnerId}`,
            isVisible: user && user.partnerId !== '' && user.partnerId > 0 && user.roleId !== 110
        },
        {
            label: 'Templates',
            icon: 'far fa-list-alt',
            to: `#/decisiontemplates/${user.partnerId}`,
            isVisible: user && user.partnerId !== '' && user.partnerId > 0 && user.roleId !== 110
        },
        {
            label: 'Users',
            icon: "fas fa-users",
            to: `#/users/${user.partnerId}`,
            isVisible: user && user.partnerId !== '' && user.partnerId > 0 && user.roleId !== 110
        },
        {
            label: 'System Admin',
            to: '#/sysadmin',
            isVisible: user && user.roleId == 110,
            icon: 'fas fa-cogs'
        }, {
            label: 'Make Decisions',
            to: '#/makedecisions',
            isVisible: !user || user.roleId !== 110,
            icon: 'fas fa-arrow-circle-left'
        }
    ];

    return nav.filter(x => x.isVisible);
}


